import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BuildingTypeModel } from '../models/classes/building';

@Injectable({
  providedIn: 'root',
})

export class BuildingtypeService {
  ip =environment.ipServer;
  private userUrl = ``;
  buildingtypes: BuildingTypeModel[] = [];
  buildingstyles: BuildingTypeModel[] = [];
  
  constructor(private http: HttpClient) {}

  getBuildingTypes(): Observable<BuildingTypeModel[]> {
    this.userUrl = `${this.ip}/api/buildingkind/GetBuildingKind`;
    return this.http.get<BuildingTypeModel[]>(this.userUrl).pipe(
      map((data) => (this.buildingtypes = data)),
      catchError(this.handleError)
    );
  }

  getBuildingKindStyles(): Observable<BuildingTypeModel[]> {
    this.userUrl = `${this.ip}/api/BuildingKindStyle/GetStyles`;
    return this.http.get<BuildingTypeModel[]>(this.userUrl).pipe(
      map((data) => (this.buildingstyles = data)),
      catchError(this.handleError)
    );
  }

  updateBuildingStyles(types: BuildingTypeModel[]) {
    this.userUrl = `${this.ip}/api/BuildingKindStyle`;
    return this.http.post(this.userUrl, types,{ observe: 'response' });
  }
  private handleError(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
